import { Link } from "react-router-dom";
import { GitBranch, Layers } from "lucide-react";
import { useBranches, inr } from "@/lib/branch";
import { ShareLinks } from "@/components/ShareLinks";

export const BranchStrip = () => {
  const ctx = useBranches();
  if (!ctx || ctx.branches.length === 0) return null;
  const { current, branches } = ctx;
  const list = current ? [current] : branches.filter((b) => b.status === "active");
  const sum = (k) => list.reduce((a, b) => a + (b[k] || 0), 0);
  return (
    <div className="bg-white border border-[#FEE2E2] rounded-2xl p-5 space-y-4" data-testid="branch-strip">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-[#7F1D1D] font-display font-bold">
          {current ? <GitBranch className="w-5 h-5 text-[#DC2626]" /> : <Layers className="w-5 h-5 text-[#DC2626]" />}
          {current ? `${current.name} · ${current.referral_code}` : `All Branches · ${list.length} active`}
        </div>
        <Link to="/branches" className="text-sm text-[#B91C1C] underline" data-testid="branch-strip-manage">Manage branches</Link>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3 text-sm">
        {[["Direct referrals", sum("direct_referrals")], ["Downline", current ? current.downline_members : "see My Branches"],
          ["Verified orders", sum("verified_orders")], ["Eligible sales", inr(sum("eligible_sales"))], ["Commission", inr(sum("earned_commission"))]].map(([k, v]) => (
          <div key={k}><div className="text-[10px] uppercase text-[#94A3B8]">{k}</div><div className="font-numbers font-semibold text-[#7F1D1D]" data-testid={`branch-strip-${k.replace(/\s/g, "-").toLowerCase()}`}>{v}</div></div>
        ))}
      </div>
      {current?.status === "active" && <ShareLinks code={current.referral_code} />}
    </div>
  );
};
